import http from "../requestBase";

const API_BASE = "/api/Locations/Translations";
/**
 * @typedef {string} GUID
 */
/**
 * Update the Translation of a Location for a GIven CountryCode/Language
 * @param {GUID} guid The Location GUID
 */
function update(guid, data) {
  return http.put(`${API_BASE}/${guid}`, data);
}

function deleteByGuid(guid) {
  return http.delete(`${API_BASE}/${guid}`);
}

export default {
  update,
  deleteByGuid,
};



// WEBPACK FOOTER //
// ./src/services/Locations/LocationTranslation.js